const state = {
  bonuses: {
    steps: {
      one: { active: true, patient: null },
      two: { active: false, bonus_task: null, doctor: null },
      three: { active: false }
    },
    current: 'one',
    button: false
  }
}

const mutations = {
  SET_STEP(state, step) {
    Object.keys(state.bonuses.steps).map(function (objectKey, index) {
      var item = state.bonuses.steps[objectKey]
      if (step == objectKey) item.active = true
      else item.active = false
    })
  },
  SET_PATIENT(state, patient) {
    state.bonuses.steps.one.patient = patient
  },
  SET_BONUS_TASK(state, bonus_task) {
    state.bonuses.steps.two.bonus_task = bonus_task
  },
  SET_DOCTOR(state, doctor) {
    state.bonuses.steps.two.doctor = doctor
  },
  SET_CURRENT(state, current) {
    state.bonuses.current = current
  },
  SET_BUTTON(state, button) {
    state.bonuses.button = button
  }
}

const actions = {
  setStep: ({ commit }, step) => {
    commit('SET_STEP', step)
  },
  setPatient: ({ commit }, patient) => {
    commit('SET_PATIENT', patient)
  },
  setBonusTask: ({ commit }, bonus_task) => {
    commit('SET_BONUS_TASK', bonus_task)
  },
  setDoctor: ({ commit }, doctor) => {
    commit('SET_DOCTOR', doctor)
  },
  setCurrent: ({ commit }, current) => {
    commit('SET_CURRENT', current)
  },
  setButton: ({ commit }, button) => {
    commit('SET_BUTTON', button)
  }
}

const getters = {
  bonuses: state => {
    return state.bonuses
  }
}

export default {
  state,
  mutations,
  actions,
getters}



// WEBPACK FOOTER //
// ./src/store/modules/bonuses.js